<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Configure action summary settings including actionable response criteria, target TAT, and color themes for different
      legend types.
    </p>
  </div>

  <div class="adf-loader" *ngIf="!configurationLoaded">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <div class="adf-settings-card" *ngIf="configurationLoaded">
    <form [formGroup]="summaryForm" class="adf-settings-form">
      <!-- Actionables -->
      <div class="adf-setting-row adf-setting-row--stack" *ngIf="hasPrimaryRating">
        <div class="adf-setting-copy">
          <span class="adf-setting-label">Responses to be considered as Actionables</span>
          <p class="adf-setting-desc">
            Only the responses belonging to the range defined in this section will be considered as Actionables
            and a graphical representation of the same will reflect in the Action Summary.
          </p>
        </div>

        <div class="adf-setting-control adf-setting-control--wide">
          <div class="adf-time-pair">
            <div class="adf-time-field">
              <label class="adf-field-label" for="from-rating">From</label>
              <input type="number" class="adf-input" id="from-rating"
                formControlName="actionableFromRating"
                step="1"
                (input)="onWholeNumberInput('from', $any($event.target))"
                (change)="onActionableFromChange($any($event.target).value, $any($event.target))"
                [attr.min]="fromRatingMin" [attr.max]="fromRatingMax">
            </div>
            <div class="adf-time-field">
              <label class="adf-field-label" for="to-rating">To</label>
              <input type="number" class="adf-input" id="to-rating"
                formControlName="actionableToRating"
                step="1"
                (input)="onWholeNumberInput('to', $any($event.target))"
                (change)="onActionableToChange($any($event.target).value, $any($event.target))"
                [attr.min]="toRatingMin" [attr.max]="toRatingMax">
            </div>
          </div>

          <div class="adf-table-wrap" *ngIf="actionablesHistory.length > 0">
            <table class="adf-table">
              <thead>
                <tr>
                  <th class="adf-table-col-sno">S.no.</th>
                  <th>History of Updates made for Actionables</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let actionable of actionablesHistory; let i = index">
                  <td class="adf-table-col-sno">{{ i + 1 }}</td>
                  <td>
                    Responses rated {{ actionable.min }} to {{ actionable.max }} from {{ actionable.start }}
                    to {{ actionable.end }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="adf-info-notes" *ngIf="actionablesHistory.length > 0">
            <p>All changes will be applied from 0000 hrs of the next day.</p>
            <p>Once modified, Actionables cannot be updated for the next 24 hours.</p>
            <p *ngIf="lastActionableAddedBy && lastActionableAddedOn">
              Last updated: {{ lastActionableAddedOn }} by {{ lastActionableAddedBy }}
            </p>
          </div>
        </div>
      </div>

      <!-- Target TAT -->
      <div class="adf-setting-row adf-setting-row--stack">
        <div class="adf-setting-copy">
          <label class="adf-setting-label" for="target-tat">Target TAT (in Hours)</label>
          <p class="adf-setting-desc">
            TAT (Turnaround Time) is the time taken to close a response. It is calculated from the response
            creation time till first update as Closed.
          </p>
        </div>
        <div class="adf-setting-control adf-setting-control--stack">
          <input type="text" inputmode="decimal" autocomplete="off" class="adf-input adf-input--sm" id="target-tat"
            formControlName="targetTAT"
            (input)="onTargetTatInput($any($event.target))">
        </div>
      </div>

      <!-- Color Theme -->
      <div class="adf-setting-row adf-setting-row--stack">
        <div class="adf-setting-copy">  
          <span class="adf-setting-label">Color Theme for Legends</span>
          <p class="adf-setting-desc">
            Customize colors and labels for different legend types in action summaries
          </p>
        </div>

        <div class="adf-setting-control adf-setting-control--wide">
          <div class="adf-color-theme"> 
            <select class="adf-select adf-select--tab" [ngModel]="selectedTab"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onTabChange($event)">
              <option value="" disabled>Select Tab</option>
              <option value="count">Count</option>
              <option value="ageing">Ageing</option>
              <option value="tat">TAT</option>
            </select>

            <ng-container *ngIf="selectedTab">
              <div class="adf-color-buckets">
                <div class="adf-color-bucket">
                  <input type="text" class="adf-input"
                    formControlName="greenBucketLabel"
                    (input)="onBucketFieldChange('greenBucketLabel', $any($event.target).value)"
                    placeholder="Green bucket label">
                  <label class="adf-color-swatch" title="Green bucket color">
                    <input type="color" class="adf-color-input"
                      [disabled]="readonly"
                      [value]="summaryForm.get('greenBucketColor')?.value"
                      (input)="onBucketFieldChange('greenBucketColor', $any($event.target).value)">
                  </label>
                </div>

                <div class="adf-color-bucket">
                  <input type="text" class="adf-input"
                    formControlName="redBucketLabel"
                    (input)="onBucketFieldChange('redBucketLabel', $any($event.target).value)"
                    placeholder="Red bucket label">
                  <label class="adf-color-swatch" title="Red bucket color">
                    <input type="color" class="adf-color-input"
                      [disabled]="readonly"
                      [value]="summaryForm.get('redBucketColor')?.value"
                      (input)="onBucketFieldChange('redBucketColor', $any($event.target).value)">
                  </label>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="adf-footer">
        <button type="button" class="adf-btn adf-btn--ghost" (click)="cancelConfiguration()"
          [disabled]="!isSaveEnabled || isCancelling || readonly">Cancel</button>
        <button type="button" class="adf-btn adf-btn--primary" (click)="saveConfiguration()"
          [disabled]="!isSaveEnabled || isSaving || readonly">Save</button>
      </div>
    </form>
  </div>
</div>
